import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const ImproveIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 11 13" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M5.98043 0.534257C5.64559 0.199417 5.10181 0.199417 4.76697 0.534257L0.481019 4.82021C0.146179 5.15505 0.146179 5.69883 0.481019 6.03367C0.815859 6.36851 1.35964 6.36851 1.69448 6.03367L4.51785 3.20762V11.4259C4.51785 11.9001 4.90091 12.2831 5.37504 12.2831C5.84918 12.2831 6.23223 11.9001 6.23223 11.4259V3.20762L9.0556 6.03099C9.39044 6.36583 9.93423 6.36583 10.2691 6.03099C10.6039 5.69615 10.6039 5.15237 10.2691 4.81753L5.98311 0.531578L5.98043 0.534257Z" />
    </SvgIcon>
  )
}
export default ImproveIcon
